import { readBoardStandardColumns } from './read'

export const boardStandardColumns = {
  readCollection: readBoardStandardColumns,
}
